import { useAtomValue } from "jotai";

import { appBarStickyHeightAtom } from "./atoms";

export const useAppBarStickyHeightValue = () => {
  const appBarStickyHeight = useAtomValue(appBarStickyHeightAtom);
  return {
    /**
     * This value is the actual height of the app bar when it's in position sticky
     */
    appBarStickyHeight,
  };
};
